import React from 'react'
import { useParams } from 'react-router-dom'
import { useContracts } from '@/v2/hooks/documents/useContracts'
import {
  usePatientFinanceInfo,
  usePatientFinancePaymentMethods,
  useLoadPaymentPlans,
} from '@/v2/hooks/usePatientFinance'
import { useClinic } from '@/v2/hooks/useClinic'
import { usePatientContext } from '@/v2/contexts/PatientContext'
import RTFinance from '@/v2/hooks/subscriptions/messages/RTFinance'
import DisabledFinance from './components/DisabledFinance'
import FinanceInfo from './components/FinanceInfo'

const Finance = () => {
  const { id } = useParams()
  const { patient } = usePatientContext()
  const { clinic, loading: loadingClinic } = useClinic()
  const { contracts, isLoading: isLoadingContracts } = useContracts(id)
  const { patientFinanceInfo, isLoading, isError } = usePatientFinanceInfo({
    patientId: id,
  })
  const {
    creditCards,
    bankAccounts,
    paymentMethods,
  } = usePatientFinancePaymentMethods({
    patientId: id,
  })

  const { paymentPlans } = useLoadPaymentPlans({
    patientId: id,
  })

  if (isLoading || isLoadingContracts) return null
  if (isError) return 'Unable to load patient balance'

  if (!loadingClinic && clinic.billingOnboardingStatus !== 'completed') {
    return <DisabledFinance onboardingStatus={clinic.billingOnboardingStatus} />
  }

  return (
    <>
      <RTFinance patientId={id} />
      <FinanceInfo
        patient={{ ...patient, contracts }}
        financeInfo={patientFinanceInfo}
        creditCards={creditCards}
        bankAccounts={bankAccounts}
        paymentMethods={paymentMethods}
        paymentPlans={paymentPlans}
      />
    </>
  )
}

export default Finance
